import { render, staticRenderFns } from "./PreDetail.vue?vue&type=template&id=5d77d44a&scoped=true"
import script from "./PreDetail.vue?vue&type=script&lang=js"
export * from "./PreDetail.vue?vue&type=script&lang=js"
import style0 from "./PreDetail.vue?vue&type=style&index=0&id=5d77d44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77d44a",
  null
  
)

export default component.exports